// extracted by mini-css-extract-plugin
export default {"container":"InfoBanner_container__Ava7B","icon":"InfoBanner_icon__BE8AS","msg":"InfoBanner_msg__CZIgi","invalid":"InfoBanner_invalid__MK-Z1"};